import { JsonSchemaValidator, ISchemaValidatorRsp } from "@Utils/JsonSchemaValidator";
import { isNumeric } from "@Utils/Micro";
import type { ToolbarIconInfo } from '@Primitive/ToolbarIconButton';
// ------------------------------------------------------------------------------------------------
export const enum ExcelTimezone {
    UTC = "UTC",
    Local = "Local"
}

// ------------------------------------------------------------------------------------------------

export const enum ExcelExportFormat {
    Excel = "Excel",
    CSV = "CSV",
    Both = "Both"
}

// ------------------------------------------------------------------------------------------------

export interface ExcelOptions {
    fileName: string;
    datetimeFormat?: string,

    /**
     * Define excel timezone (UTC or Browser/OS local)
     */
    timezone?: ExcelTimezone;

    /**
     * Save native datetime in excel case
     */
    useNativeDatetime?: boolean;
}

// =======================================================================================================
export interface TimeSeriesChartLineSettings {
    /**
     * Unique id
     */
    Id: string;

    Label: string;

    /**
     * Refers to line's color.
     */
    BackgroundColor: string;

    /**
     * Refers to label's color.
     */
    BorderColor: string;
}
// ------------------------------------------------------------------------------------------------
export interface TimeSeriesChartSettings {
    Lines: TimeSeriesChartLineSettings[];
    MaximumNumberOfElements: number;
    showGridLines: boolean;
    showBaselines: boolean;
    showPoints: boolean;
    commonAxis: boolean;
    autoTimeRange: boolean;
    focusLastValue: boolean;

    /**
     * Allows to download an excel spreadsheet (XLSX file)
     * with the extracted data from the chart.
     */
    excelDownload: boolean;
    excelOptions: ExcelOptions;
    excelExportFormat: ExcelExportFormat;

    //Toolbar
    customToolbarIcons: ToolbarIconInfo[];
    toolbarIconSize?: number;
    toolbarHeight?: number;
}
// ------------------------------------------------------------------------------------------------
export function ILineSchemeValidator() {
    return JsonSchemaValidator.GetInstance(
        "ILineSchemeValidator",
        {
            type: "array",
            items: {
                type: "object",
                properties: {
                    label: {
                        type: "string"
                    },
                    value: {
                        type: "number"
                    },
                    color: {
                        type: "string"
                    }
                },
                required: ["label", "value"]
            },
            minItems: 0
        },
        null
    );
}
// ------------------------------------------------------------------------------------------------
export function ValidatePortState(key: string, value: any): ISchemaValidatorRsp {
    // Initialize successful validation response.
    let rsp: ISchemaValidatorRsp = {
        valid: true,
        errors: null
    };

    switch (key) {
        case 'reset':
            break;
        case 'lines':
            return ILineSchemeValidator().DataValidateString(value);
        default:
            if (!isNumeric(value) || isNaN(value)) {
                rsp.valid = false;
                rsp.errors = "Invalid value type. Expecting number.";
            }
            break;
    }

    return rsp;
}
// ------------------------------------------------------------------------------------------------
